export default "__VITE_PUBLIC_ASSET__0922fb83__"